import { useContext, useEffect } from "react"
import type { UseFormSetValue } from "react-hook-form"
import { PayrollContext } from "../../../../../contexts/PayrollContext/PayrollContext"
import { useGetCompanyPaymentCurrencyCode } from "../../../hooks/useGetCompanyPaymentCurrencyCode"
import { PayrollChangeFormValues } from "../types"

interface Props {
  setValue: UseFormSetValue<PayrollChangeFormValues>
}

export const useSetPaymentCurrencyCode = ({ setValue }: Props) => {
  const { companyId } = useContext(PayrollContext)
  const paymentCurrencyCode = useGetCompanyPaymentCurrencyCode({ companyId })

  useEffect(() => {
    if (!paymentCurrencyCode) return
    setValue("paymentCurrencyCode", paymentCurrencyCode)
  }, [setValue, paymentCurrencyCode])
}
